import { useState } from 'react';
import { Box, Typography, styled, InputAdornment } from '@mui/material';
import Dialog, { DialogPrimaryButton } from './Dialog';
import InputField from './InputField';

const FieldWrapper = styled(Box)({
  marginBottom: 30,
});

const ReduceBalanceDialog = ({ open, onClose, onSubmit }) => {
  const [amount, setAmount] = useState('');
  const [note, setNote] = useState('');

  const handleClose = () => {
    setAmount('');
    setNote('');
    onClose();
  };

  const handleSubmit = () => {
    onSubmit?.({ amount, note: note.trim() });
    handleClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} title="RÉDUIRE LE SOLDE">
      <FieldWrapper>
        <InputField
          label="Montant"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          type="number"
          fullWidth
          sx={{
            '& .MuiOutlinedInput-input': {
              '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
                WebkitAppearance: 'none',
                margin: 0,
              },
              MozAppearance: 'textfield',
            },
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end" sx={{ color: '#ACACAC' }}>
                <Typography sx={{ fontSize: 18, fontWeight: 500 }}>€</Typography>
              </InputAdornment>
            ),
          }}
        />
      </FieldWrapper>
      <FieldWrapper>
        <InputField
          label="Note (optionnel)"
          value={note}
          onChange={(e) => setNote(e.target.value)}
          multiline
          minRows={4}
          maxRows={4}
          fullWidth
        />
      </FieldWrapper>
      <DialogPrimaryButton variant="contained" onClick={handleSubmit}>
        RÉDUIRE
      </DialogPrimaryButton>
    </Dialog>
  );
};

export default ReduceBalanceDialog;
